$shm_hitalama_map_widget_float_notebook $shm_hitalama_map_widget_float
	controls /
		<= List $mol_view
			sub /
				^ items /
					<= Item*0 $mol_view
						sub /
							- <= Add* $mol_button_minor
								hint \Добавить
								click? <=> add_before*? null
								sub /
									<= Add_icon* $mol_icon_plus
							<= Add* $shm_hitalama_map_widget_float_notebook_pop_over
								align \right_bottom
								Anchor <= Add_widget_anchor* $mol_button_minor
									sub /
										<= Add_widget_icon* $mol_icon_plus
								bubble_content /
									<= Add_widget_menu* $shm_hitalama_map_page_contextmenu
										item_ids_top /
										item_ids /
											\text_md
											\code_js
											\iframe
										Map_page <= Map_page
										contextmenu_real_pos /
											0
											0
							<= Item_row* $mol_view
								sub /
									<= Widget_controls* $mol_view
										minimal_width 320
										sub <= widget_controls* /
									<= Widget_delete* $mol_button_minor
										hint @ \Delete
										click? <=> widget_cut*? null
										sub /
											<= Widget_delete_icon* $mol_icon_trash_can
				<= Add*0
	add_before* null

$shm_hitalama_map_widget_float_notebook_pop_over $mol_pop_over
